import React from 'react'
import { Box, Button, Container, Grid, Typography, } from '@mui/material';
import { Link } from "react-router-dom";
import Divider from '@mui/material/Divider'; 
import LikeButton from "../../../Views/Like/likebutton";
import { APP_URL } from '../../../Config';
import notrevealed from '../../../images/notrevealed.jpg';

const Saletype = (props) => {
    return (
        <div>
            <Box className="Profile_allnft">
                <Container maxWidth='xl'>
                    <Grid container spacing={1}>
                    {props.Saleprop.length>0 && props.Saleprop.map((data,index) => (
                            <Grid key={index} item lg={3} sm={6} md={6} xs={12} marginBottom='30px'>
                                <Box className='Profile_inner'> 
                                    <Box>
                                    <Link to={`./Buydetails/${data.NFT_id}`} > 
                                    {data.NFT_image.split('.').pop()== "png" ||data.NFT_image.split('.').pop()=='jpg'||data.NFT_image.split('.').pop()=='jpeg'?
                                    <img src={data.Private==0?APP_URL+'/'+data.NFT_image:notrevealed} width='100%' className='base_pht' style={{ borderRadius: '5px' }} /> 
                                    :data.NFT_image.split('.').pop()== "mp4" ?
                                    <video width="750" height="500" controls >
                                        <source src={data.Private==0?APP_URL+'/'+data.NFT_image:notrevealed} type="video/mp4"/>
                                    </video>
                                    :data.NFT_image.split('.').pop()== "mp3" ||data.NFT_image.split('.').pop()=='aac'?
                                    <audio controls>
                                    <source src={data.Private==0?APP_URL+'/'+data.NFT_image:notrevealed} type="audio/mpeg"/>
                                    Your browser does not support the audio tag.
                                    </audio> 
                                    :<img src={data.Private==0?APP_URL+'/'+data.NFT_image:notrevealed} width='100%' style={{ borderRadius: '5px' }} />
                                    } 
                                    </Link>
                                    </Box>
                                    <Box display='flex' justifyContent='space-between' paddingY='10px'>
                                        <Box>
                                            <Typography fontWeight='600' fontSize='22' variant='h6' color='#000'>
                                            <Link to={`./Buydetails/${data.NFT_id}`}>{data.Private==0?data.NFT_name:"SECRET NFT"}</Link>
                                            </Typography>
                                        </Box>
                                        <Box>
                                            <LikeButton nft={data}/>
                                        </Box>
                                    </Box>
                                    <Divider />
                                    <Box paddingBottom='10px'>
                                        <Box>
                                            <Typography variant='h5' color='#000' fontWeight='600' fontSize='16px'>
                                                Reserved price
                                            </Typography>
                                            <Typography fontWeight='500' variant='h6' fontSize='15px' color='#000'>
                                            {data.NFT_price} {data.NFT_payment}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </Box>
        </div>
    )
}

export default Saletype;  